import { store$ } from '@redux/store';
import { selectFetchingModal, selectModal } from 'layout/redux/selectors';
import { getAnonymousId } from 'libraries/segmentAnalyticsLibrary';
import { trackEvent } from 'libraries/vwoLibrary';
import { EMPTY, filter, fromEvent, map, switchMap, take } from 'rxjs';

const SECTION_SELECTOR = '[data-section-name="homesForYou"], [data-section-name="communitiesForYou"]';
const LEAD_BUTTON_SELECTOR = '[data-lead-generator-opener]';
const CARD_SELECTOR = '[data-card]';
const LEAD_EVENT = 'spotlightPocLeadGenerated';

const getLeadButton = (event) => event.target.closest(LEAD_BUTTON_SELECTOR);
const getCard = (button) => button.closest(CARD_SELECTOR);
const isSpotlightCard = (card) => card.dataset.wasMatchedAsSpotlightResult === 'true';
const isLeadGeneratorModal = (modal) => modal.name === 'leadGenerator';

const buildLeadProperties = (experimentBucket, card) => ({
  experimentBucket,
  isSpotlight: true,
  referer: 'learning_center_module',
  cardPosition: parseInt(card.dataset.index, 10) + 1,
});

/**
 * Wires up spotlight A/B test tracking for the "Homes For You" and "Communities For You" modules.
 *
 * - Intercepts lead-button clicks on spotlight cards and, when the lead modal subsequently
 *   submits, fires a `spotlightPocLeadGenerated` VWO event.
 *
 * Safe to call immediately after the module fragment is appended to the DOM.
 */
const initSpotlightLeadTracking = () => {
  const section = document.querySelector(SECTION_SELECTOR);
  if (!section) { return; }

  const experimentBucket = section.dataset.experimentBucket;
  if (!experimentBucket) { return; }

  fromEvent(section, 'click').pipe(
    map(getLeadButton),
    filter(Boolean),
    map(getCard),
    filter(Boolean),
    switchMap((card) => {
      if (!isSpotlightCard(card)) { return EMPTY; }
      return store$.pipe(
        filter(selectFetchingModal),
        map(selectModal),
        filter(Boolean),
        filter(isLeadGeneratorModal),
      ).pipe(
        take(1),
        map(() => buildLeadProperties(experimentBucket, card)),
      );
    }),
  ).subscribe((properties) => {
    const userId = getAnonymousId();
    return trackEvent(LEAD_EVENT, userId, properties);
  });
};

export default initSpotlightLeadTracking;

